import AsyncAlpine from 'async-alpine'
import Alpine from 'alpinejs'
// import intersect from '@alpinejs/intersect'

import { setC7Config } from '@kraftwerkdesign/c7-components'
import '@kraftwerkdesign/c7-components'

import '@mux/mux-player'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import LocomotiveScroll from 'locomotive-scroll'

import { initGlobalAnimations } from './animations/global'

import { Preloader } from './components/Preloader'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { Marquee } from './components/Marquee'
import { HomepageHero } from './components/HomepageHero'
import { ButtonHover } from './components/ButtonHover'
import { initCookieConsent } from './cookieconsent'

Preloader()
initCookieConsent()

setC7Config({
  tenant: 'marami-vineyards',
  tenantId: 'marami-vineyards',
  apiBase: 'https://api.commerce7.com',
})

gsap.registerPlugin(ScrollTrigger)

window.Alpine = Alpine
Alpine.plugin(AsyncAlpine)

const locoScroll = new LocomotiveScroll({
  initCustomTicker: (render) => {
    gsap.ticker.add(render)
  },
  destroyCustomTicker: (render) => {
    gsap.ticker.remove(render)
  },
  lenisOptions: {
    prevent: (node) =>
      node.id == 'c7-content' ||
      node.classList.contains('c7-content') ||
      node.id == 'c7-modal',
  },
})
/*
  Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  https://github.com/darkroomengineering/lenis/blob/main/README.md#gsap-scrolltrigger
*/
window.lenis = locoScroll.lenisInstance
locoScroll.lenisInstance?.on('scroll', ScrollTrigger.update)
gsap.ticker.lagSmoothing(0)

document.addEventListener('DOMContentLoaded', () => {
  initGlobalAnimations()
})

// Alpine.plugin(intersect) // probably doesn't work with scroll smoother
Alpine.data('header', Header)
Alpine.data('hero', Hero)
Alpine.data('homepageHero', HomepageHero)
Alpine.data('buttonHover', ButtonHover)

Alpine.directive('marquee', Marquee)

Alpine.asyncData(
  'vineyardDetails',
  () => import('./components/VineyardDetails'),
)
Alpine.asyncData('scrollingGrid', () => import('./components/ScrollingGrid'))
Alpine.asyncData('imageSlider', () => import('./components/Slider'))
Alpine.asyncData('wineSlider', () => import('./components/WineSlider'))
Alpine.asyncData(
  'homepageWineIntro',
  () => import('./components/HomepageWineIntro'),
)
Alpine.asyncData('journeySlider', () => import('./components/JourneySlider'))
Alpine.asyncData('maramiMap', () => import('./components/Map'))
Alpine.asyncData('miniWineSlider', () => import('./components/MiniWineSlider'))
Alpine.asyncData(
  'copyToClipboard',
  () => import('./components/CopyToClipboard'),
)

Alpine.start()
